<style scoped lang="scss">

</style>

<template>
    <div v-if="application">
        <fieldset class="agreement-container">
            <legend class="agreement-title">
                Affidavit Statements
            </legend>

            <div class="uk-grid">
                <div class="uk-width-1-1">
                    <h4>Instructions:</h4>
                    <p>
                        Read each statement and initial and check agree below for each household member.
                    </p>
                </div>
            </div>

            <div class="uk-grid">
                <div class="uk-width-1-1">
                    <div class="uk-block uk-block-default">
                        <ol class="uk-margin-bottom">
                            <li style="margin-bottom:.5em;">Under penalty of perjury, I/we certify that all of the information in this
                                affidavit is truthful and the event(s) identified above has/have contributed to my/our need for assistance.
                            </li>
                            <li style="margin-bottom:.5em;">I/we understand and acknowledge that {{ application.program.agency_name }} and/or its agents
                                may investigate the accuracy of my/our statements, may require me/us to provide supporting
                                documentation, and that knowingly submitting false information may violate Federal and/or
                                state law.
                            </li>
                            <li style="margin-bottom:.5em;">I/we understand that if I/we am/are asked and unable to provide documentation
                                to support the hardship information I/we provided on this Hardship Affidavit, I/we may be
                                required to repay any assistance I/we receive, and I/we may be reported to the U.S.
                                Department of Treasury and the State of {{ application.program.state }}.
                            </li>
                            <li style="margin-bottom:.5em;">I/we understand that if I/we have intentionally defaulted on my/our existing
                                mortgage or rent obligations, engaged in fraud or misrepresented any fact(s) in connection
                                with this Hardship Affidavit, or if I/we do not provide all of the required documentation,
                                I may not qualify for assistance from {{ application.program.agency_name }}
                            </li>
                            <li>I/we understand that {{ application.program.agency_name }} and/or its agents will use this information to evaluate my/our
                                eligibility for assistance, but {{ application.program.agency_name }} and its agents is not obligated to
                                offer me/us assistance based solely on the representations in this affidavit.
                            </li>
                        </ol>
                    </div>
                </div>
            </div>

            <div class="uk-grid" v-if="application.household">
                <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                    <div v-if="member.age >= 18">
                        <validated-section :errors="errors" :field="'signature_'+member.id">
                            <signature-box @updated="onSignatureUpdated"
                               :user-key="member.id"
                               :is-signed="signatureData[member.id] && signatureData[member.id].affidavit_signed_at !== null"
                               :completed="signatureData[member.id] && signatureData[member.id].completed"
                               :name="member.first_name + ' ' + member.last_name"
                               :color="programSettings['primary-program-color']"
                            ></signature-box>
                        </validated-section>


                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";

    export default {
        name: "Step4",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        methods: {
            hasError(field) {
                for(var i in this.errors) {
                    if(this.errors[i].field === field) return true;
                }
                return false;
            },
            getErrors(field) {
                for(var i in this.errors) {
                    if(this.errors[i].field === field) return this.errors[i].errors;
                }
                return [];
            },
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-step-4`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, {
                                affidavit_signed_at: member.affidavit_signed_at,
                                completed: true
                            })
                        }
                    }
                })
            },
            onSignatureUpdated($event) {
                console.log($event);
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { affidavit_signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },
            async validateStep() {

                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].affidavit_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    await this.$store.dispatch('Application/fetch', this.application.id);
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-4`, data);
            }
        }
    }
</script>
